<template>
  <ul>
    <li v-for="item in enhancedItems" :key="item.name">
      <AgsLink
        hover="underline"
        :highlight-active="false"
        :class="{
          'text-black-40 underline': item.name === selected,
        }"
        size="base"
        class="px-3 pt-3 font-medium"
        :to="item.to"
        @click="onClickItem(item)"
      >
        {{ $t(`sorting_select.${item.name}`) }}
      </AgsLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { OdoscopeSortValue } from '#layers/base/utils/odoscopeSort'

const props = defineProps({
  items: {
    type: Array as PropType<SortValue[] | OdoscopeSortValue[]>,
    required: true,
  },
  selected: {
    type: String as PropType<string>,
    default: '',
  },
})
const emit = defineEmits(['click:item'])
const route = useRoute()
const { toLocalePath } = useRouteHelpers()

const onClickItem = (item: SortValue) => {
  emit('click:item', item)
}
const enhancedItems = computed(() =>
  props.items.map((item: any) => ({
    ...item,
    to: toLocalePath({
      params: { ...route.params },
      query: { ...route.query, sort: item.query, page: undefined },
    }),
  })),
)
</script>
